import appEntryPoint from './browserApp/appEntryPoint';
import StoreDevHelperProvider from './browserApp/components/StoreDevHelperProvider';
import DevLoader from './browserApp/components/devLoader';
import translation from './browserApp/components/translation';
import createRemoteDataProvider from './browserApp/components/translation/createRemoteDataProvider';
import { DataProvider, DataProviderItem, RemoteDataProviderResponse } from './browserApp/components/translation/types';
import useRemoteDataProvider from './browserApp/components/translation/useRemoteDataProvider';
import {
    TranslatedComponent,
    LangTrls,
    TranslationHOCProps,
} from './browserApp/components/translation/useTranslations';
import useExperimentCheckOnElementShown from './browserApp/hooks/useExperimentCheckOnElementShown';
import reducer from './browserApp/modules/baseReducer';
import experimentCheckFunction, {
    experimentControlCheckFunction,
    experimentGroupCheckFunction,
} from './browserApp/modules/experiments/experimentCheckFunction';
import { experimentsReducer } from './browserApp/modules/experiments/store';
import useExperiment, {
    useExperimentControl,
    useExperimentGroup,
} from './browserApp/modules/experiments/useExperiment';
import useExperimentCheckFunction, {
    useExperimentControlCheckFunction,
    useExperimentGroupCheckFunction,
} from './browserApp/modules/experiments/useExperimentCheckFunction';
import fetcher from './browserApp/modules/fetcher';
import initSentry from './browserApp/modules/initSentry';
import { setServiceName } from './browserApp/modules/serviceName';
import { formatFromTo, format, formatNewLine, formatToReactComponent, numberFormatter } from './browserApp/modules/trl';
import Conversion from './browserApp/modules/trl/Conversion';
import getConversionType from './browserApp/modules/trl/getConversionType';
import { useSelector } from './browserApp/modules/useSelector';
import { useServerEnv } from './utils/useServerEnv';

export {
    useExperiment,
    experimentsReducer,
    useExperimentControl,
    useExperimentGroup,
    useExperimentCheckFunction,
    useExperimentControlCheckFunction,
    useExperimentGroupCheckFunction,
    experimentCheckFunction,
    experimentControlCheckFunction,
    experimentGroupCheckFunction,
};

export { initSentry };
export { fetcher };
export { translation };
export type { TranslatedComponent, LangTrls, TranslationHOCProps };
export { reducer };
export { useSelector };
export { format, formatFromTo, formatNewLine, formatToReactComponent, numberFormatter };
export { useServerEnv };
export { DevLoader };
export { useExperimentCheckOnElementShown };
export { StoreDevHelperProvider };
export { useRemoteDataProvider, createRemoteDataProvider };
export type { DataProvider, DataProviderItem, RemoteDataProviderResponse };
export { Conversion, getConversionType };
export { setServiceName };

export default appEntryPoint;
